// Tipo y gama de producto como dimensiones del alcance; los comparten las promos de venta y de crédito.
import type {
    ProductCategoryWire,
    ProductTier,
} from '@/api/services/retail-catalog/backoffice/contract';
import type { ScopeChipTone } from '@/shared/patterns/ScopeChips';

export type ProductScopeCategory = ProductCategoryWire;
export type ProductScopeTier = ProductTier;

export const PRODUCT_CATEGORY_OPTIONS: { value: ProductScopeCategory; label: string }[] = [
    { value: 'PHONE', label: 'Teléfonos' },
    { value: 'BUNDLE', label: 'Kits' },
    { value: 'SIM', label: 'SIM' },
    { value: 'MODEM', label: 'Módem' },
    { value: 'ACCESSORY', label: 'Accesorios' },
];

export const PRODUCT_TIER_OPTIONS: { value: ProductScopeTier; label: string }[] = [
    { value: 'LOW', label: 'Gama baja' },
    { value: 'MID', label: 'Gama media' },
    { value: 'HIGH', label: 'Gama alta' },
    { value: 'PREMIUM', label: 'Premium' },
];

const SCOPE_CATEGORY_ORDER: readonly ProductScopeCategory[] = [
    'PHONE',
    'SIM',
    'MODEM',
    'ACCESSORY',
    'BUNDLE',
];

/** Tipos en el orden del alcance: Teléfonos primero, que es lo que más se promueve; Kits al final. */
export const SCOPE_CATEGORY_OPTIONS = [...PRODUCT_CATEGORY_OPTIONS].sort(
    (a, b) => SCOPE_CATEGORY_ORDER.indexOf(a.value) - SCOPE_CATEGORY_ORDER.indexOf(b.value),
);

export const PRODUCT_CATEGORY_LABEL = Object.fromEntries(
    PRODUCT_CATEGORY_OPTIONS.map((option) => [option.value, option.label]),
) as Record<ProductScopeCategory, string>;

export const PRODUCT_TIER_LABEL = Object.fromEntries(
    PRODUCT_TIER_OPTIONS.map((option) => [option.value, option.label]),
) as Record<ProductScopeTier, string>;

/** La gama va en violeta, como en el mock. */
export const PRODUCT_TIER_TONE: ScopeChipTone = {
    chip: 'border-promo-soft-border bg-promo-soft text-promo',
    dot: 'bg-promo',
};

export const MISSING_PRODUCT_TYPE =
    'Falta en el sistema: el catálogo todavía no tiene este tipo de producto.';

/** Tipos del mock que no existen en el catálogo; se pintan deshabilitados. */
export const MISSING_PRODUCT_TYPES = ['Tarjetas', 'Prepago/Postpago'] as const;
